































import { Component, Prop, Vue, Watch, Mixins, Emit } from "vue-property-decorator";
import { State, Getter, Action, Mutation } from "vuex-class";
import anime from "animejs";
import Swiper from 'swiper';

@Component({
  components: {
  }
})
export default class ContentSlide extends Vue {
  @State(state => state.app.scrollingByScreens) scrollingByScreens!: boolean;

  @Prop({ default: '' })
  titleNormal!: string;

  @Prop({ default: '' })
  titleBold!: string;

  @Prop({ default: '' })
  image!: string;

  @Prop({ default: '' })
  mobileImage!: string;

  @Prop({ default: '' })
  text!: string;

  @Prop({ default: 0 })
  number!: number;

  openLearnMoreForm() {
    window.dispatchEvent(new Event("openForm:learnMore"));
  }
}
